import { memo } from 'react';

import UserIconSVG from '@/assets/user-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IUserIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={UserIconSVG} {...props} />;

export const UserIcon = memo(IUserIcon) as typeof IUserIcon;
